export default __webpack_public_path__ + "static/media/uploader-oneTouchVerioIQ-2.0f392d2b.png";